module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'dzmrqhlx',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
